import { initialiseVerticalTimelineItems } from "../src/VerticalTimelineItems";

initialiseVerticalTimelineItems();
